export enum SurveyStatuses {
  notStarted = 0,
  welcome = 5,
  demographics = 10,
  introduction = 20,
  respondentInvitations = 25,
  indicatorQuestions = 30,
  effectivenessQuestions = 40,
  extraValueQuestions = 45,
  commentsQuestions = 50,
  finalWords = 60,
  completeSurvey = 70
}
